<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';

	import circleBackroundImages from './images/IW-PRICING-BG.jpg';

	// images

	let { costPerSquareFoot, costAverage, bgColor = 'red' } = $props();
</script>

<div
	class="
   grid size-auto place-items-center content-center items-center justify-center
   md:aspect-square
 "
>
	<span class="circle grid w-44">
		<div class="col-span-full row-span-full">
			<Image src={circleBackroundImages} alt="" />
		</div>
		<div
			class="col-span-full row-span-full flex items-center justify-center"
			class:bg-[hsla(360,77%,68%,0.75)]={bgColor === 'red'}
			class:bg-[hsla(45,70%,62%,0.75)]={bgColor === 'yellow'}
			class:bg-[hsla(95,38%,60%,0.75)]={bgColor === 'green'}
			class:bg-[hsla(200,60%,60%,0.75)]={bgColor === 'blue'}
		>
			<p class="flex flex-col items-center gap-y-2 p-6 text-white!">
				<span class="text-4xl"><strong>${costPerSquareFoot}</strong>/sf</span>
				<span class="max-w-[12ch] leading-none break-normal"
					>or just ${costAverage} for an average window</span
				>
			</p>
		</div>
	</span>
</div>
